import { Class_Colors, Hex_Colors } from '../../../../../config/colors';
import Menu from '../../menus/model/Menu';
import MenuIcon from '../../menus/model/MenuIcon';
import ProjectFirstType from './ProjectFirstType';
import ProjectPartners from './ProjectPartners';
import ProjectsTranslation from './ProjectsTranslation';
export default class Projects {
    constructor(projects) {
        const { id, status, sort, project_link, project_type, image_color, brand_logo, has_project_header_optional_data_right, partners, project_first_type, translations } = projects;
        this.id = id;
        this.status = status;
        this.sort = sort;
        this.project_type = project_type;
        this.has_project_header_optional_data_right = has_project_header_optional_data_right;
        this.project_first_type = project_first_type
            ? new ProjectFirstType(project_first_type)
            : undefined;
        this.partners = partners ? partners.map(partner => new ProjectPartners(partner)) : [];
        this.project_link = project_link ? new Menu(project_link) : undefined;
        this.hex_color = image_color;
        this.brand_logo = brand_logo ? new MenuIcon(brand_logo) : undefined;
        this.color_class = getColorClassFromAPI(image_color);
        this.translations = translations
            ? translations.map(translation => new ProjectsTranslation(translation))
            : [];
    }
}
function getColorClassFromAPI(hex_color) {
    if (hex_color) {
        switch (hex_color) {
            case Hex_Colors.HEX_PRIM_BLUE:
                return Class_Colors.COLOR_BLUE;
            case Hex_Colors.HEX_PRIM_ORANGE:
                return Class_Colors.COLOR_ORANGE;
            case Hex_Colors.HEX_PRIM_YELLOW:
                return Class_Colors.COLOR_YELLOW;
            case Hex_Colors.HEX_PRIM_RED:
                return Class_Colors.COLOR_RED;
            case Hex_Colors.HEX_PRIM_GREEN:
                return Class_Colors.COLOR_GREEN;
            default:
                return '';
        }
    }
}
